import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tp0008',
    ecrans: ['00-2']
});
